module.exports = __webpack_public_path__ + "static/media/deliveryman.2669ab51.png";